/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TabsModule } from '../core/components/tabs';
import { GeofenceFormComponent } from './components';
import { GeofenceDrawingControlsComponent, GeofenceFormContainerComponent } from './containers';
import { GeofenceIconModule } from './geofence-icon.module';
import { GeofenceEffects, geofenceReducer } from './store';

@NgModule({
  declarations: [GeofenceFormContainerComponent, GeofenceDrawingControlsComponent, GeofenceFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    GeofenceIconModule,
    TabsModule,
    StoreModule.forFeature('geofence', geofenceReducer),
    EffectsModule.forFeature([GeofenceEffects]),
    MatLegacyDialogModule,
    MatLegacySelectModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatLegacyInputModule,
    MatLegacyCheckboxModule
  ],
  exports: [GeofenceFormContainerComponent, GeofenceDrawingControlsComponent]
})
export class GeofenceModule {}
